'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'rotate';
var width = 512;
var height = 512;
var aliases = [128260,"sync-alt"];
var unicode = 'f2f1';
var svgPathData = ['M48 376l0 54.1 54.1-54.1-54.1 0zM410.1 136l54.1 0 0-54.1c-18.1 18-36.1 36.1-54.1 54.1z', 'M512.2 24c0-9.7-5.8-18.5-14.8-22.2S478.1 .2 471.2 7L419.4 58.8C318.8-24.7 169.3-19.3 75.1 75 31.9 118.2 7.3 173.1 1.5 229.5 .1 242.7 9.7 254.5 22.9 255.9s25-8.2 26.3-21.4c4.7-45.9 24.7-90.4 59.8-125.5 75.5-75.5 194.6-80.8 276.2-16L335.1 143c-6.9 6.9-8.9 17.2-5.2 26.2S342.4 184 352.1 184l136.1 0c13.3 0 24-10.7 24-24l0-136zm-75.1 85l27.1-27.1 0 54.1-54.1 0 27-27zm73.6 173.6c1.4-13.2-8.2-25-21.4-26.3s-25 8.2-26.3 21.4c-4.7 45.8-24.7 90.4-59.8 125.5-75.5 75.5-194.6 80.8-276.2 16L177.1 369c6.9-6.9 8.9-17.2 5.2-26.2S169.8 328 160.1 328L24 328c-13.3 0-24 10.7-24 24L0 488c0 9.7 5.8 18.5 14.8 22.2S34.1 511.8 41 505l51.8-51.8c100.6 83.5 250.1 78.1 344.3-16.2 43.2-43.2 67.8-98.1 73.6-154.5zM48 430.1l0-54.1 54.1 0-54.1 54.1z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRotate = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;